// eslint-disable-next-line import/no-anonymous-default-export
export default {
    "title": "ADOR",
    "welcome": "Welcome",
    "target_group": "Target Group",
    "administration": "Administration",
    "housing_companies": "Housing Companies",
    "import": "Import",
    "generate_analysis": "Generate Analysis",
    "search": "Search",
    "select": "Select",
    "items": "items",
    "page": "page",
    "ok": "OK",
    "reset": "Reset",
    "submit": "Submit",
    "english": "English",
    "finnish": "Finnish",
    "language": "Language",
    "logout": "Logout",
    "total": "Total",
    "priority": "Priority No.",
    "city": "City",
    "name_of_loan": "Loan Name",
    "type_of_loan": "Type Of Loan",
    "name_of_the_loan": "Name Of The Loan",
    "current_bank_of_the_loan": "Current Bank Of The Loan",
    "financial_analysis": "Financial Analysis",
    "shareholder_analysis": "Shareholder Analysis",
    "ltv_analysis": "LTV analysis",
    "company_information": "Company Information",
    "pts": "PTS",
    "loan_comparison": "Loan Comparison",
    "tender_request_submitted": "Tender request submitted",
    "company": "Company",
    "buildingtype": "Building type",
    "landownership": "Land ownership",
    "yearofintroduction": "Year of introduction",
    "numberofbuildings": "Number of buildings",
    "numberoffloors": "Number of floors",
    "apartments": "Apartments",
    "commercialapartments": "Commercial apartments ",
    "otherpremises": "Other premises ",
    "building_type": "Building type",
    "land_ownership": "Land ownership",
    "year_of_introduction": "Year of introduction",
    "number_of_buildings": "Number of buildings",
    "number_of_floors": "Number of floors",
    "commercial_apartments": "Commercial apartments",
    "other_premises": "Other premises",
    "address": "Address ",
    "lender": "Lender",
    "remaining_capital": "Remaining Capital",
    "remaining_loan_period": "Remaining loan period",
    "margin": "Margin",
    "reference_interest_rate": "Reference base rate",
    "shortening_style": "Shortening style",
    "years": "years",
    "competitive_loan": "Competitive Loan",
    "housing_company": "Housing Company",
    "hc": "HC",
    "num_of_shareholders_share_10": "Num of Shareholders,% share >=10%",
    "peoplewho_own_more_than_1_apartment": "People,who own more than 1 apartment",
    "%_of_share": "% of share",
    "of_share": "% of share",
    "number_of_share_holder": "Number of share holder",
    "number_of_appartment": "Number of apartment",
    "number_of_apartments": "Number of apartments",
    "apartments_incl_business_spaces": "Apartments (incl business spaces)",
    "person_owned_and_lives_in": "Person-owned and lives-in",
    "person_owned_and_non_lives_in": "Person-owned and non-lives-in",
    "company_owned": "Company owned",
    "percent_of_total_shares": "% of total shares",    
    "of_total_shares": "% of total shares",
    "percent_of_total_m2": "% of total m2",
    "of_total_m2": "% of total m2",
    "num_of_apartments": "Num of apartments",
    "business_space_m2": "Business space m2",
    "apartment_m2": "Apartment m2",
    "number_of_car_spaces": "No. of car spaces",
    "number_of_other_spaces": "Number of other spaces",
    "car_spaces": "Car spaces",
    "person_owned": "Person-owned",
    "list_of_all_shareholder": "List of all Shareholder",
    "apartment_name": "Apartment Name",
    "shareholder_name": "Shareholder name",
    "home_address_of_shareholder": "Home address of Shareholder",
    "total_share_of_that_shareholder": "Total share of that Shareholder",
    "square_meter": "Square meter",
    "ownership_percentage": "Ownership Percentage",
    "business_id": "Business Id",
    "people_who_own_more_than_one_apartment": "People, who own more than one apartment",
    "num_of_appartment_they_own_in_this_hc": "Num. of apartment they own in this HC",
    "how_many_shares_they_own": "How many shares they own",
    "the_percentage_of_the_shares_owned_of_hc": "The percentage of the shares owned of HC",
    "company_shareholder": "Company Shareholder",
    "shareholders_people_who_own_more_than_10%_shares": "Shareholders (people) who own more than 10% Shares",
    "shareholders_people_who_own_more_than_10_shares": "Shareholders (people) who own more than 10% Shares",
    "year_of_construction": "Year of construction",
    "propertytype": "Property type",
    "sales": "Sales",
    "plot": "Plot",
    "postalcode": "Postal code",
    "street": "Street",
    "hspsoldapartments": "HSP - Sold apartments",
    "apartmenttype": "Apartment type",
    "numberofrooms": "Number of rooms",
    "eurm2_lower_quartile": "eur/m2 (lower quartile)",
    "eurm2_upper_quartile": "eur/m2 (upper quartile)",
    "numberofsoldapartments": "Number of sold apartments",
    "hspsoldcarspaces": "HSP - Sold car spaces",
    "type": "Type",
    "averagedebtfreeprice": "Average debt-free price",
    "debtfreepricelowerquartile": "Debt-free price(lower quartile)",
    "debtfreepriceupperquartile": "Debt-free price(upper quartile)",
    "amountofsoldcarspaces": "Amount of sold car spaces",
    "notable_done_renovations": "Notable done renovations",
    "notable_upcoming_renovations": "Notable upcoming renovations",
    "renovation_type": "Renovation type",
    "scope": "Scope",
    "description": "Description",
    "starting_year": "Starting year",
    "data_description": "Data Description",
    "status": "Status",
    "actions": "Actions",
    "used_for": "Used For",
    "last_import_done_date_and_time": "Last Import Done (Date And Time)",
    "click_or_drag_file_to_this_area_to_upload": "Click or drag file to this area to upload",
    "support_for_a_single_upload_strictly_prohibit_from_uploading_company_data_or_other_band_files": "Support for a single upload. Strictly prohibit from uploading company data or other band files",
    "account_master": "Account Master",
    "housewise_account_categorization": "Housewise Account Categorization",
    "customer_data": "Customer Data",
    "accounting_data": "Accounting Data",
    "osakerekisteri_shareholder_data": "Osakerekisteri-Shareholder Data",
    "patrick_dimyhtio": "Patrick dimyhtio",
    "dw_lainarekisteri_loan_data": "Dw lainarekisteri -Loan Data",
    "hsp_rivitieto_hsp_sales_data": "Hsp rivitieto - Hsp Sales Data",
    "start_year_is_required": "Start year is required",
    "end_year_is_required": "End year is required",
    "property_type": "Property type",
    "please_select_property_type": "Please select Property Type",
    "erillistalo": "Erillistalo",
    "kerrostalo": "Kerrostalo",
    "omakotitalo": "Omakotitalo",
    "paritalo": "Paritalo",
    "rivitalo": "Rivitalo",
    "tontti": "Tontti",
    "please_select_land_ownership": "Please select Land ownership",
    "oma": "Oma",
    "vuokra": "Vuokra",
    "muu": "Muu",
    "last_24_months": "Last 24 months",
    "last_12_months": "Last 12 months",
    "last_6_months": "Last 6 months",
    "kiinteistön_hinta_arvio_perustuu_kiinteistönvälittäjien_hintaseurantapalvelun_tietokantaan_toteutuneista_kaupoista_hinta_arviossa_on_otettu_huomioon_muun_muassa_alueella_myytyjen_kohteiden_todelliset_myyntihinnat_hinta_arvio_ei_välttämättä_vastaa_kiinteistön_todellista_hintaa_vaan_antaa_tietoa_alueen_keskimääräisistä_myyntihinnoista_hinta_arvio_perustuu_tilastoihin_ja_keskiarvoihin_mikä_tarkoittaa_sitä_että_kiinteistön_yksilöllisiä_piirteitä_esim_asuntojen_kunto_ei_oteta_huomioon_tuloksissa": "Kiinteistön hinta-arvio perustuu kiinteistönvälittäjien hintaseurantapalvelun tietokantaan toteutuneista kaupoista. Hinta-arviossa on otettu huomioon muun muassa alueella myytyjen kohteiden todelliset myyntihinnat. Hinta-arvio ei välttämättä vastaa kiinteistön todellista hintaa, vaan antaa tietoa alueen keskimääräisistä myyntihinnoista. Hinta-arvio perustuu tilastoihin ja keskiarvoihin, mikä tarkoittaa sitä, että kiinteistön yksilöllisiä piirteitä (esim. asuntojen kunto) ei oteta huomioon tuloksissa.",
    "postal_code": "Postal code",
    "kohteen_lainat,_kiinteiston_indikatiivinen_hinta_arvio_ja_ltv": "Kohteen lainat, kiinteiston indikatiivinen hinta-arvio ja LTV",
    "lainan_nimi": "Lainan nimi",
    "paaoma_jaljella": "Paaoma jaljella",
    "indik_hinta_arvio_ka": "Indik hinta-arvio ka",
    "indik_hinta_arvio_alakvartiili": "Indik hinta-arvio alakvartiili",
    "indik_hinta_arvio_ylakvartiili": "Indik hinta-arvio ylakvartiili",
    "ltv": "LTV",
    "ltv_min": "LTV min",
    "ltv_max": "LTV max",
    "apartments_and_indicative_price_estimate_per_apartment_type": "Apartments and indicative price estimate per apartment type",
    "rooms": "Rooms",
    "area": "Area",
    "amount_of_apartments": "Amount of apartments",
    "average_eurm2": "Average eur/m2",
    "average_indicative_price_estimate": "Average indicative price estimate",
    "indicative_price_estimatelower_quartile": "Indicative price estimate(lower quartile)",
    "indicative_price_estimateupper_quartile": "Indicative price estimate(upper quartile)",
    "kohteen_autopaikat_ja_indikatiivinen_hinta_arvio": "Kohteen autopaikat ja indikatiivinen hinta-arvio",
    "autopaikkojen_lkm_osakkeelliset": "Autopaikkojen lkm (osakkeelliset)",
    "velaton_hinta_ka": "Velaton hinta ka",
    "indik_arvo_ka": "Indik arvo ka",
    "indik_arvo_alakvartiili": "Indik arvo alakvartiili",
    "indik_arvo_ylakvartiili": "Indik arvo ylakvartiili",
    "hsp_sold_apartments": "HSP - Sold apartments",
    "apartment_type": "Apartment type",
    "number_of_rooms": "Number of rooms",
    "average_eurm2_ka": "Average eur/m2 ka",
    "number_of_sold_apartments": "Number of sold apartments",
    "hsp_sold_car_spaces": "HSP - Sold car spaces",
    "average_debt_free_price": "Average debt-free price",
    "debt_free_pricelower_quartile": "Debt-free price(lower quartile)",
    "debt_free_priceupper_quartile": "Debt-free price(upper quartile)",
    "amount_of_sold_car_spaces": "Amount of sold car spaces",
    "katu": "Katu",
    "map": "Map",
    "file_uploaded_successfully": "File uploaded successfully.",
    "file_validation_failed": "File validation failed.",
    "file_validated_successfully": "File validated successfully.",
    "customer_id": "Customer ID",
    "customer_name": "Customer Name",
    "housing_manager_name": "Housing Manager Name",
    "housing_manager_email": "Housing Manager Email",
    "housing_manager_phone": "Housing Manager Phone",
    "number_of_apartment_patdim_data": "Number of Apartment (Pat.Dim Data)",
    "number_of_apartment_shareholder_data": "Number of Apartment (Shareholder Data)",
    "number_of_business_space_patdim": "Number of Business Space (Pat.Dim)",
    "number_of_car_space_patdim_data": "Number of Car Space (Pat.Dim Data)",
    "number_of_car_space_shareholder_data": "Number of Car Space (Shareholder Data)",
    "no_data": "No Data",
    "of": "of",
    "january": "January",
    "february": "February",
    "march": "March",
    "april": "April",
    "may": "May",
    "june": "June",
    "july": "July",
    "august": "August",
    "september": "September",
    "october​": "October​",
    "november": "November",
    "december": "December",
    "generate_pdf": "Generate PDF",
    "asunto_oy_virontörmänkatu_10": "Asunto Oy Virontörmänkatu 10",
    "analyysi_indikatiivista_tarjousta_varten": "Analyysi indikatiivista tarjousta varten",
    "analysis_for_indicative_loan_offer​": "Analysis for indicative loan offer​",
    "sisällys​​​": "Sisällys​​​",
    "perustiedot_yhtiöstä_ja_kilpailutettavasta_lainasta": "Perustiedot yhtiöstä ja kilpailutettavasta lainasta",
    "analyysin_yhteenveto​​": "Analyysin yhteenveto​​",
    "markkinahintapohjainen_indikaatio_loan_to_value": "Markkinahintapohjainen indikaatio - Loan to Value",
    "taloudellinen_analyysi": "Taloudellinen analyysi",
    "osakeanalyysi": "Osakeanalyysi",
    "basic_information": "Basic information",
    "build_year": "Build year",
    "number_of_business_spaces": "Number of business spaces",
    "num_of_car_spaces": "Num of car spaces",
    "of_which_hc_owned": "Of which HC owned",
    "housing_manager": "Housing manager",
    "bank": "Bank",
    "sent_to_email": "Sent to (email)",
    "offer_received": "Offer received",
    "offer_valid_until": "Offer valid until",
    "current_capital": "Current capital",
    "margin_value": "Margin Value",
    "loaner_group": "Loaner Group",
    "loan_time_left": "Loan Time Left",
    "loan_time_remaining": "Loan time remaining",
    "loan_time": "Loan time",
    "repayment_method": "Repayment method",
    "number_of_yearly_payment": "Number of yearly payment",
    "reference_rate": "Reference rate",
    "housing_company_accountant": "Accountant",
    "payment_type": "Payment type",
    "yearly_payments": "Yearly Payments",
    "last_reference_data_check": "Last Reference Date Check",
    "next_reference_data_check": "Next Reference Date check",
    "interest_rate": "Interest Rate",
    "name_of_the_bank": "Name of the Bank",
    "tendered_loan": "Tendered Loan",
    "kpl": "kpl",
    "ltv_analysis_market_based_indicative_value_estimation": "LTV analysis - market-based indicative value estimation",
    "loans_indicative_value_estimation_of_the_property_and_ltv": "Loans, indicative value estimation of the property and LTV",
    "loan_name": "Loan Name",
    "loan_number": "Loan Number",
    "loan_invoicing_model": "Invoicing model",
    "Recurring": "Recurring",
    "Non-Recurring": "Non-Recurring",
    "Invoicing model updated successfully": "Invoicing model updated successfully",
    "Failed to update invoicing model": "Failed to update invoicing model",
    "tender_details": "Tender details",
    "capital": "Capital",
    "estimated_value_average": "estimated value, average",
    "estimated_value_lower_quartile": "estimated value, lower quartile",
    "estimated_value_upper_quartile": "estimated value, upper quartile",
    "breakdown_of_value_estimation_for_hcs_apartments_business_spaces_and_car_spaces": "Breakdown of value estimation for HC's apartments, business spaces and car spaces",
    "build_year_of_property": "Build year of property",
    "filtered_build_years": "Filtered build years",
    "zip": "zip",
    "region": "region",
    "sales_period": "Sales period",
    "room_number": "Room number",
    "total_m2_summarized": "Total m2 (summarized)",
    "total_number_of_apartments": "Total number of apartments",
    "em2_average": "e/m2 average",
    "number_of_sales": "Number of sales",
    "estimation_basis": "Estimation basis",
    "business_spaces": "Business spaces",
    "total_number_of_business_spaces": "Total number of business spaces",
    "total_m2": "Total m2",
    "total_number_of_car_spaces": "Total number of car spaces",
    "average_price": "Average price",
    "disclaimers": "Disclaimers",
    "disclaimer": "Disclaimer",
    "last": "Last",
    "months": "Months",
    "pts_22_–_tehdyt_merkittävät_korjaukset": "KPTS (3/3) – Tehdyt merkittävät korjaukset",
    "pts_12_–_korjaustarpeet": "KPTS (1/3) – Korjaustarpeet",
    "save": "Save",
    "empty": "Empty",
    "osakeanalyysi_12": "Osakeanalyysi (1/2)",
    "osakeanalyysi_22": "Osakeanalyysi (2/2)",
    "x_apartments_and_y_business_spaces_dynamic_text": "X apartments and Y business spaces",
    "share_of_apartment_shares": "Share of apartment shares",
    "yksityisomistuksessa—_asuu_huoneistossa_people_owned_lives_in_hc": "People-owned, lives in HC",
    "yritysten_omistuksessa_company_owned": "Company-owned",
    "yksityisomistuksessa—_asuu_muualla_people_owned_lives_elsewhere": "People-owned, lives elsewhere",
    "taloudellinen_analyysi​": "Taloudellinen analyysi​",
    "hoitokuluihin_12_kk_rullaava_ka_suhteutettu_maksukyvykkyys_vrt_tavoite_ja_kaikkien_kohteiden_ka": "Hoitokuluihin (12 kk rullaava ka) suhteutettu maksukyvykkyys vrt. tavoite ja kaikkien kohteiden ka",
    "hoitotuotot_hoitokulut_ja_urakkakulut": "Hoitotuotot, hoitokulut ja urakkakulut",
    "autopaikkoja_4_kpl__x_number_of_car_spaces_dynamic_table__text": "X number of car spaces",
    "num_of_spaces": "Num of spaces",
    "share_of_car_space_shares": "Share of car space shares",
    "yksityisomistuksessa__people_owned": "People-owned",
    "yritysten_omistuksessa__company_owned": "Company-owned",
    "henkilöriskit__shareholderrisks_people__both_=10_ownershipsand_multiple_apartments": "Henkilöriskit / Shareholderrisks (people) ** (both >=10% ownershipsand multiple apartments)",
    "yritykset__company_shareholders": "Company shareholders",
    "share_of_hc_shares": "Share of HC shares",
    "aloitus": "Aloitus",
    "kunnossapitotarve": "Kunnossapitotarve",
    "toimenpiteen_laajuus": "Toimenpiteen laajuus",
    "tarkka_kuvaus": "Tarkka kuvaus",
    "please_wait": "Please wait...",
    "export_pdf": "Export PDF",
    "updated_successfully": "Updated successfully",
    "analyysin_yhteenveto": "Analyysin yhteenveto",
    "loan_to_value_indikaatio​": "Loan to Value - indikaatio​",
    "maksu_kyvykkyys​": "Maksu-kyvykkyys​",
    "osakkaat": "Osakkaat",
    "ei_huomioitavaa": "Ei huomioitavaa",
    "huomioitavaa​": "Huomioitavaa​",
    "tendering_list_for_moderator": "Tendering list for moderator",
    "loan_offer_comparison_summary_for_moderator": "Loan offer comparison summary for moderator",
    "open_loan_tendering_case": "Open loan tendering case",
    "ahc": "AHC",
    "loan_id": "Loan ID",
    "loan_amount_eur": "Loan amount €",
    "loan_amount": "Loan amount",
    "moderator": "Moderator",
    "preliminary_potential_savings": "Preliminary potential savings",
    "retta_earning_potential": "Retta earning potential",
    "date_of_ahc_board_meeting": "Date of AHC board meeting",
    "deadline": "Deadline",
    "offers_received": "Offers received",
    "retta_earning": "Retta earning",
    "replaced_by_loan": "Replaced by loan",
    "mark_as_invoiced": "Mark as invoiced",
    "mark": "Mark",
    "closed_loan_tendering_case": "Closed loan tendering case",
    "nordea": "Nordea",
    "aktia": "Aktia",
    "danske_bank": "Danske Bank",
    "handelsbanken": "Handelsbanken",
    "hypo": "HYPO",
    "op": "OP",
    "s_pankki": "S-Pankki",
    "export": "Export",
    "loans_indicative_price_estimate_of_the_property_and_ltv": "Loans, indicative price estimate of the property and LTV",
    "average_indicative_price_lower_quartile": "Average indicative price (lower quartile)",
    "average_indicative_price_upper_quartile": "Average indicative price (upper quartile)",
    "car_spaces_and_indicative_price_estimate": "Car spaces and indicative price estimate",
    "amount_of_car_spaces": "Amount of car spaces",
    "average_indicative_value": "Average indicative value",
    "indicative_value_lower_quartile": "Indicative value (lower quartile)",
    "indicative_value_upper_quartile": "Indicative value (upper quartile)",
    "business_spaces_and_indicative_price_estimate": "Business spaces and indicative price estimate",
    "amount_of_business_spaces": "Amount of business spaces",
    "single_loan_tendering_view": "Single loan tendering view",
    "quotation_submit_time": "Quotation submit time",
    "documents": "Documents",
    "quotation_received_and_valid_until": "Quotation received and valid until",
    "payments_per_year": "Payments/year",
    "interest_base": "Interest base",
    "loan_span": "Loan span",
    "downpayment_type": "Downpayment type",
    "sanction": "Sanction",
    "fee": "Fee",
    "document": "Document",
    "one_loan_quotation": "One loan quotation",
    "to_bank": "To Bank",
    "documents_and_date": "Documents & Date",
    "winner": "Winner",
    "feedback": "Feedback",
    "do_you_want_to_send_tender_request": "Do you want to send tender request?",
    "do_you_want_to_chane_deadline": "Do you want to change deadline?",
    "change_deadline": "Change deadline",
    'internal_quotaion_deadline':'Internal Quotaion Deadline',
    'deadline_for_quotation_changed_successfully':'Deadline for quotation changed successfully',
    "cancel":"Cancel",
    "select_loan":"Select Loan",
    "are_you_sure_you_want_to_move_this_loan_to_the_tendering_list":"Are you sure you want to move this loan to the tendering list?",
    "tenders":"Tenders",
    "select_date":"Select Date",
    "please_input_deadline_date":"Please input Deadline Date",
    "please_input_your_reason":"Please input your Reason!",
    "yes":"Yes",
    "loan_is_already_tendered":"Loan is already tendered",
    "reason":"Reason",
    "deadline_date":"Deadline Date",
    "please_input_dedline_date":"Please input Deadline Date",
    "email": "Email",
    "phone": "Phone",
    "name": "Name",
    "single_loan_view_moderator": "Single loan view (moderator)",
    "loaner_grouped": "Loaner (grouped)",
    "sannoitsija": "sannoitsija",
    "number_of_tenders_received": "No. of tenders received",
    "notes": "Notes",
    "start_tendering": "Start Tendering",
    "files": "Files",
    "banks_participating_this_tendering": "Banks participating this tendering",
    "select_all_select_none": "Select all / select none",
    "saastopnakki": "Saastopnakki",
    "upload": "Upload",
    "send": "Send",
    "tender_edited_successfully": "Tender edited successfully",
    "tender_save_successfully":"Tender Save Successfully",
    "total_records": "Total Records",
    "pts_analysis_data":"PTS Analysis Data",
    "share_holder_analysis":"Share Holder Analysis",
    "perust_hierarkia": "Perust Hierarkia",
    "pts_analysis": "PTS Analysis",
    "sännöitsijä": "Housing manager",
    "kirjanpitäjä": "Accountant",
    "moderaattori": "Moderator",
    "single_loan_view": "Single Loan View ",
    "ador_analysis": "Ador-analyysi",
    "shareholder": "Shareholder",
    "allekirjoitettu_tilinpaatos_ja_toimintaketomus": "Allekirjoitettu tilinpäätös ja toimintakertomus",
    "isannoitijantodistu": "Isännöitsijäntodistus",
    "energy_certificate": "Energy certificate",
    "deadline_for_quotation": "Deadline for quotation",
    "margin_percentage": "Margin %",
    "valid_until": "Valid Until",
    "attachment": "Attachment",
    "choose_file": "Choose file..",
    "contact_info": "Contact Info",
    "message": "Message",
    "estimated_price_of_mortgage_transfer": "Estimated Price of Mortgage Transfer",
    "payment_method": "Payment Method",
    "reference_rate_base": "Reference Rate Base",
    "payment_interval_months": "Payment Interval (months)",
    "loan_span_years": "Loan Span (years)",
    "new_capital_amount": "New Capital Amount €",
    "sanction_for_yearly_payment": "Sanction for yearly repayment %",
    "arrangement_fee": "Arrangement Fee €",
    "transferring_payment_transaction_mandatory": "Transferring Payment Transaction Mandatory",
    "no": "No",
    "additional_attachment": "Additional attachment",
    "loan_tender_id": "Loan Tender ID",
    "maksuvalmius": "Maksuvalmius",
    "maksuvalmiuserittely": "Maksuvalmiuserittely",
    "no_of_buildings": "No. of buildings",
    "quotaion_deadline": "Quotation Deadline",
    "num_of_shareholders_share_=10": "Num of Shareholders,% share >=10%",
    "end_tendering": "End Tendering",
    "message_to_winning_bank": "Message to winning bank",
    "attachments": "Attachments",
    "end_tendering_select_winner_moderator": "End tendering - select winner (Moderator)",
    "are_you_sure_you_want_to_end_this_tender": "Do you really want to end this tender and send the messages ?",
    "validate_data": "Transform Data",
    "loan_tendering_costs": "Loan tendering costs",
    "costs_or_savings_related_to_reference_rate_check": "Costs or savings related to reference rate check",
    "loan_cost_comparison_and_savings": "Loan cost comparison and savings",
    "1_refinancing_costs_covered_with_income_financing": "1. Refinancing costs covered with income financing",
    "2_refinancing_costs_capitalised": "2. Refinancing costs capitalised",
    "recommendation": "Recommendation",
    "other_terms": "Other terms",
    "loan_transfer_sanction": "Loan transfer sanction %",
    "banks_arrangement_fee_€": "Banks arrangement fee €",
    "loan_transfer_sanction_€": "Loan transfer sanction €",
    "estimated_price_of_mortage_transfer": "Estimated price of mortage transfer",
    "rettas_fee_vat_24": "Retta's fee (Vat 0 %)",
    "total_costs": "Total costs",
    "total_costs2": "Total costs",
    "current_reference_rate_of_the_loan": "Current reference rate of the loan %",
    "time_remaining_to_reference_rate_check_months": "Time remaining to reference rate check (months)",
    "reference_rate_today": "Reference rate today",
    "costprofit_of_reference_rate_change_€": "Cost/profit of reference rate change €",
    "1st_year_savings": "1st year savings",
    "total_savings": "Total Savings",
    "total_loan_incl_refinancing_costs": "Total loan (incl. refinancing costs)",
    "interest_rate_terms": "Interest rate terms",
    "shareholder_repayments": "Shareholder repayments",
    "optional_annual_repayments": "Optional annual repayments",
    "optional_repayment_method": "Optional repayment method",
    "payment_transaction_transfer": "Payment transaction transfer",
    "viitekoron_vaihtoehto": "Viitekoron vaihtoehto",
    //manager single view
    "single_loan_view_for_housing_manager": "Single loan view for housing manager",
    "accept": "Accept",
    "reject": "Reject",
    "path": "Path",
    "export_loan_comparison": "Export loan comparison",
    "if_the_refinancing_costs_are_capitalised_general_meeting_decision_is_required": "If the refinancing costs are capitalised, general meeting decision is required.",
    "mikäli_järjestelypalkkiot_maksetaan_tulorahoituksella_ja_lainapääoma_pidetään_samana_ei_tarvita_yhtiökokousta_laskennassa_pankin_jälleenrahoituskustannukset_on_jyvitetty_tasaisesti_lyhennysjaksoille_ja_rettan_palkkio_maksetaan_ensimmäisen_vuoden_aikana": "Mikäli järjestelypalkkiot maksetaan tulorahoituksella ja lainapääoma pidetään samana, ei tarvita yhtiökokousta. Laskennassa pankin jälleenrahoituskustannukset on jyvitetty tasaisesti lyhennysjaksoille ja Rettan palkkio maksetaan ensimmäisen vuoden aikana.",
    "print": "Print",
    "view": "View",
    "bank_name": "Bank Name",
    "city_id": "City ID",
    "city_name": "City Name",
    "contact_name": "Contact Person",
    "email_contact": "Email Contact",
    "phone_number": "Phone Number",
    "maksuvalmius​":"Maksuvalmius​",
    "kuluihin_12_kk_rullaava_ka_suhteutettu_maksuvalmius": "Kuluihin (12 kk rullaava ka) suhteutettu maksuvalmius",
    "tuotot_ja_kulut": "Tuotot ja kulut",
    "autopaikat_lkm": "Autopaikat lkm",

    /////New keys TBD
    "add_bank_contact_details": "Add bank contact details",
    "edit_bank_contact_details": "Edit bank contact details",
    "bank_management": "Bank management",
    "contract": "Contract",
    "send_services_request_to_hm": "Send services request",
    "are_you_sure_you_want_to_send_service_request_to_hm": "Are you sure you want to send service request to HM?",
    "3kk_euribor": "3kk Euribor",
    "6kk_euribor": "6kk Euribor",
    "12kk_euribor": "12kk Euribor",
    "tender_deadline_is_passed": "Tender deadline is passed",
    "are_you_sure_you_want_to_update_reference_rate" : "Are you sure you want to update reference rate ?", 
    "tender_id": "Tender ID",
    "asuin__ja_liikehuoneistot_x_kpl": "Asuin- ja liikehuoneistot X kpl",
    "deleted_successfully": "Deleted successfully",
    "pdf":"PDF",
    "paikat_lkm": "Paikat lkm",
    "count": "Count(Source/Target)",
    "select_all": "Select all",
    "date_last_refresh": "Date last refresh",
    "are_you_sure_you_want_to_delete_this_attachment": "Are you sure you want to delele this attachment?",
    "delete": "Delete",
    "are_you_sure_you_want_to_select_this_option": "Are you sure you want to select this option?",
    "no_offer": "No offer",
    "are_you_sure_you_want_to_submit":"Are you sure you want to submit?",
    "current_loan_terms": "Current loan terms",
    "offers": "Offers",
    "dont_tender_tendering_cases": "Don't tender tendering cases",
    "revert": "Revert",
    "edit": "Edit",
    "add_bank": "Add bank",
    "add_bank_name": "Add bank name",
    "please_enter_bank_name": "Please enter bank name",
    "completed": "Completed",
    "not_completed": "Not completed",
    "you_already_have_data_in_this_analysis_do_you_want_to_fresh_upload": "You already have data in this analysis, do you want to fresh upload?",
    "all": "All",
    "dont_tender": "Don't Tender",
    "potential": "Potential",
    "proposed_for_tendering": "Proposed for tendering",
    "tendering_postponed": "Tendering postponed",
    "tendering_rejected": "Tendering rejected",
    "approved_for_tendering": "Approved for tendering",
    "tendering_ongoing": "Tendering ongoing",
    "tendering_deadline_closing_soon": "Tendering deadline closing soon",
    "check_loan_comparison": "Check loan comparison",
    "comparison_sent": "comparison sent",
    "signed_meeting_minutes_received": "Signed meeting minutes received",
    "waiting_for_decision": "Waiting for decision",
    "end_tender": "Tendering closed",
    "waiting_for_signed_bond": "Waiting for signed bond",
    "bond_sent_to_accounting": "Bond sent to accounting",
    "invoiced": "Invoiced",
    "done": "Done",
    "tendering_declined": "Tendering declined",
    "requested_for_tendering": "Requested for tendering",
    "marketing_materials": "Marketing materials",
    "warning":"Warning",
    "contracts": "Contracts",
    "upload_contracts": "Upload contracts",
    "add_comment": "Add comment",
    "maximum_500_charecter": "Maximum 500 charecter",
    "file_uploaded_succesfully": "File uploaded succesfully",
    "housing_manager_profile": "Housing manager profile",
    "do_you_want_to_accept_this_tender": "Do you want to accept this tender?",
    "tender_accepted": "Tender accepted",
    "do_you_want_to_reject_this_tender": "Do you want to reject this tender?",
    "bank_form": "Bank form",
    "please_enter_number": "Please enter number",
    "remove_file": "Remove file",
    "please_select_payment_method": "Please select payment method",
    "please_select_base_rate": "Please select base rate",
    "please_enter_number_between_1_and_12": "Please enter number between 1 and 12",
    "satellite": "Satellite",
    "tender_request_successfully_sent": "Tender request successfully sent",
    "download": "Download",
    "please_enter_city_name": "Please enter city name",
    "bank_contact_details": "Bank contact details",
    "the_input_is_not_valid_email": "The input is not valid E-mail!",
    "please_enter_phone_number_between_8_to_12_digits": "Invalid phone number",
    "please_enter_contact_name": "Please enter contact name",
    "date": "Date",
    "tender_rejected":"Tender rejected",
    "please_select_deadline": "Please select deadline!",
    "please_enter_notes": "Please enter notes!",
    "please_select_status": "Please select status",
    "please_select_bank": "Please select bank",
    "are_you_sure_you_want_to_delete_bank_contact_details": "Are you sure you want to delete bank contact details?",
    "bank_contact_updated_successfully": "Bank contact updated successfully",
    "bank_contact_deleted_successfully": "Bank contact deleted successfully",
    "removefile": "Remove File",
    "please_select_attachment": "Please select attachment",
    "Other": "muu",
    "please_select_valid_until_date": "Please select valid until date",
    "euribor_rates_daily": "Euribor rates daily (suomenpankki.fi)",
    "please_attach_document": "Please attach document",
    "other": "Other",
    "tender_closed_successfully": "Tender is closed successfully",
    "of_hc_shares": "% of HC shares",
    "of_hc_m2": "% of HC m2",
    "lives_in_hc_elsewhere": "lives in HC/elsewhere (y/n)",
    "m2": "M2",
    "files_from_housing_manager": "Files from housing manager",
    "bank_pdf": "Bank",
    "apartments_pdf": "Apartments",
    "service_request_sent_to_hm": "Service request sent to HM",
    "no_response": "No response",
    "true": "True",
    "false": "False",
    "are_you_sure_you_want_to_move_this_loan_back_to_the_target_group": "Are you sure you want to move this loan back to the Target group?",
    "no_status": "No Status",
    "export_ador_analysis": "Export Ador Analysis",
    "y": "Y",
    "n": "N",
    "num_of_apartments_pdf": "Num of apartments",
    "housing_manager_comment": "Housing manager comment",
    "bank_saved_successfully": "Bank saved successfully",
    "bank_updated_successfully": "Bank updated successfully",
    "bank_deleted_successfully": "Bank deleted successfully",
    "mismatch_data": "Mismatch data found",
    "completed_without_erroneous_records": "Completed without erroneous records",
    "file_management": "File management",
    "ador_contract": "Ador contract",
    "file_description": "File Description",
    "other_spaces": "Other spaces",
    "next_reference_data_check_ci": "Next Reference Date check",
    "edit_new_loan": "Edit new loan",
    "create_new_loan": "Create new loan",
    "create_loan":"Create loan",
    "estimated_amount_of_capital": "Estimated amount of capital",
    "reason_for_the_loan": "Reason for the loan",
    "new_loan": "New loan:",
    "please_enter_reason_for_the_loan":"Please enter reason for the loan",
    "please_enter_estimated_amount_of_capital": "Please enter estimated amount of capital",
    "please_enter_name_of_the_loan": "Please enter name of the loan",
    "please_select_housing_company": "Please select housing company",
    "sanction_percentage": "Sanction %",
    "ongoing_renovations": "Ongoing renovations",
    "pts_23_–_kaynnissa_olevat_korjaukset": "KPTS (2/3) – Käynnissä olevat korjaukset",
    "muut_tilat_y_kpl": "Y number of other spaces",
    "please_note_that_the_selected_loan_is_a_split_loan": "Please note that the selected loan is a split loan. Do you still want to proceed?",
    "next_reference_date": "Next reference date",
    "loan_time_modified": "Loan period, modified",
    "are_you_sure_you_want_to_leave_an_offer":"Are you sure you want to submit?",
    "verify_to_your_account": "Verify to your account",
    "code_is_required": "Code is required",
    "security_code": "Security code",
    "verify": "Verify",
    "invalid_code": "Invalid code",
    "login_successfully": "Login successfully.",
    "contact_save_successfully": "Contact save successfully",
    "tendering_notes": "Notes",
    "complete": "Complete",
    "tender_request_already_sent_for_this_loan": "Tender request already sent for this loan.",
    "transformation": "Transformation",
    "data_transformed_successfully": "Data transformed successfully",
    "reset_to_original": "Reset to original",
    "re_tender": "Re-Tender",
    "are_you_sure_you_want_to_re_tender_this_loan":"Are you sure you want to re-tender this loan?",
    "in_active": "In-active",
    "active": "Active",
    "active_Shareholder": "Active Shareholder",
    "in_active_shareholder": "In-active Shareholder",
    "re_activate_shareholder": "Re-activate Shareholder",
    "do_you_want_to_re_activate_the_shareholder_analysis_of_the_housing_company": "Do you want to re-activate the shareholder analysis of the housing company",
    "data_saved_successfully": "Data Saved Successfully",
    "do_you_want_to_disable_the_shareholder_analysis_of_the_housing_company": "Do you want to disable the shareholder analysis of the housing company",
    "disable_shareholder": "Disable Shareholder",
    "update_disable_duration": "Update disable duration",
    "the_input_is_not_valid_email_bank": "The input is not valid E-mail!",
    "logs": "Logs",
    "purpose_of_the_loan": "Purpose of the loan",
    "requested_payment_interval": "Requested payment interval",
    "requested_reference_rate": "Requested reference rate",
    "requested_payment_method": "Requested payment method",
    "please_select_reference_rate" : "Please select reference rate",
    "loan_save_successfully" : "Loan saved successfully",
    "minimum_value_1" : "Minimum Value 1",
    "maximum_value_12" : "Maximum Value 12",
    "payment_method_nl": "Payment Method",
    "reference_rate_base_nl": "Reference Rate Base",
    "payment_interval_months_nl": "Payment Interval (months)",
    "maximum_loan_time": " Maximum loan time",
    "capital_2": "Capital",
    "requested_euribor": "Requested Euribor",
    "name_of_the_loan_2": "Loan name",
    "service_request_is_failed": "Service request is failed",
    "enter_numeric_digit_number_less_than_100": "Please enter numeric value only less than 100"
}